import { Col, Row, Space, Button } from "antd";
import { Form, Formik } from "formik";
import { useState } from "react";

import { Input, Select } from "components/form";
import styles from "../styles/NewFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";

const MasterDataFilter = ({
  initialValues = {},
  shiftOptions = [],
  titleNameOptions = [],
  employeeTypeOptions = [],
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  welfareList = [],
  welfareOption = [],
  welfareTypeOptions = [],
  dataFlag = null,
  roleOption = [],
  shiftDropDown = [],
  selectedMenu = null,
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [optionType, setOptionType] = useState(null);
  const flagPage = null;
  const { modifiedStatus = [] } = useStatusFlagOption()

  console.log('selectedMenu', selectedMenu);

  const statusOption = [
    {
      value: "All",
      name: "All"
    },
    {
      value: "Active",
      name: "Active"
    },
    {
      value: "Inactive",
      name: "Inactive"
    },
    {
      value: "Delete",
      name: "Delete"
    }
  ]
  console.log("roleOptionroleOption", roleOption);
  return (

    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit({
          ...values,
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (

          <Form>
            {dataFlag == "master" && (
              <Row gutter={[24, 16]} className={styles.filter} >
                <Col span={8}>
                  <Input
                    name="commonTypeName"
                    label={t(`masterdata.label.${selectedMenu}`)}
                    placeholder={t(`masterdata.label.${selectedMenu}`)}
                    size="large"
                  />
                </Col>
                <Col span={8}>
                  <Input
                    name="description"
                    label={t('masterdata.label.description')}
                    placeholder={t('masterdata.label.description')}
                    size="large"
                  />
                </Col>
                {/* <Col span={6}>
                  <Input
                    name="PayrollData"
                    label={t('payrollData')}
                    placeholder={t('payrollData')}
                    size="large"
                  />
                </Col> */}
                <Col span={8}>
                  <Select
                    name="statusFlag"
                    label={t('translation.status')}
                    placeholder={t('translation.status')}
                    size="large"
                    options={modifiedStatus}
                  />
                </Col>


              </Row>
            )}

            <Row justify="end">
              <Space size={10} className={styles.filterbtn}>
                <Button type="default" onClick={resetForm}>
                  {t('common.clear').toUpperCase()}
                </Button>
                <Button type="primary" htmlType="submit" style={{ backgroundColor: "var(--button-color)" }}>
                  {t("creatTamplete.Search").toUpperCase()}
                </Button>
              </Space>
            </Row>

          </Form>
        );
      }}
    </Formik>
  );
};

export default MasterDataFilter;
